<template>
    <div>
        <div class="d-flex justify-space-between mb-10" style="align-items: center;">
            <h2>
                Lista de Embarque
            </h2>
        </div>

        <div class="d-flex gap-12">
            
            <form class="w-100 flex-grow-1 mr-6">
                <v-text-field
                    class="pt-5 pb-5"
                    chips
                    clearable
                    hide-details
                    hide-selected
                    prepend-icon="mdi-magnify"
                    label="Search"
                    solo
                />
            </form>

            <div class="d-flex align-center">
                <v-btn @click="openCreateRomaneio = true" color="primary" class="mr-2" :disabled="selected.length == 0">
                    Gerar Romaneio
                </v-btn>
            </div>

        </div>
        
        <div v-on:mousemove="updateMouseCoordinates" class="w-100">
            <v-data-table
                v-model="selected"
                :style="{ overflowX: 'auto' }"
                :headers="headersComp"
                :items="items"
                :items-per-page="pagination.limit"
                class="elevation-1 element header-table text-no-wrap cursor-pointer"
                disable-sort
                hide-default-footer
                @click:row="rowClick"
                show-select 
            >

                <template v-slot:[`header.data-table-select`]>
                    <!-- vazio, ou coloca algo fixo -->
                    <span></span>
                </template>
            
                <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="display: flex; justify-content: center;">
                            <v-checkbox
                            :input-value="isSelected"
                            @click.stop="select(!isSelected)"
                            :disabled="selected.some(s => s.job !== item.job)"
                            />
                        </div>
                        </template>
                        <span class="bg-deep-purple text-white px-2 py-1 rounded">
                            {{
                                selected.some(s => s.job !== item.job)
                                ? 'Não é possível selecionar itens de JOBs diferentes'
                                : 'Clique para selecionar este item'
                            }}
                        </span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.dataCriacao`]="{ item }">
                    <span>
                        {{ item.dataCriacao ? new Date(item.dataCriacao).toLocaleDateString() : "Não informado" }}
                    </span>
                </template>
                
                <template v-slot:[`item.dataEmbarque`]="{ item }">
                    <span>
                        {{ item.dataEmbarque ? new Date(item.dataEmbarque).toLocaleDateString() : "Não informado" }}
                    </span>
                </template>

            </v-data-table>
        </div>

        <v-menu v-model="rowMenu.showMenu" :position-x="rowMenu.menuX" :position-y="rowMenu.menuY">
            <v-list dense rounded>
                <v-list-item
                    v-for="(action, index) in actions"
                    :key="index"
                    link
                    @click="action.handle()"
                >

                    <v-list-item-icon>
                    <v-icon :color="action.color">{{ action.icon }}</v-icon>
                    </v-list-item-icon>
                    
                    <v-list-item-content>
                        <v-list-item-title>{{ action.title }}</v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
            </v-list>
        </v-menu>

        <div class="text-center pt-2 pagination">
            <v-pagination v-model="page" :length="pageCount" @input="inputPagination"></v-pagination>
        </div>

        <entityFormDialog v-model="open" :schema="schema" :entity="entity" :form="schema.form ? schema.form : undefined"
            :value="open" :loading="true" @dialog="($event) => (open = $event)" @confirm="saveListEmb"
            @cancel="open = !open">
        </entityFormDialog>

        <CreateRomaneioView 
            :open="openCreateRomaneio"
            :selectedItems="selected"
            @save="generatedRomaneio"
            @close="openCreateRomaneio = false"
            :itemsSelected="selected"
        />

    </div>

</template>

<script>
import Vue from 'vue';
import EntityService from "@/services/entityService";
import schemaService from "@/services/schemaService";
import CreateRomaneioView from './CreateRomaneioView.vue';

export default {
    name: 'PackingListView',
    //mixins: [entityPageMixin],
    components: {
        EntityFormDialog: () => import("@/components/dialogs/entityFormDialog.vue"),
        CreateRomaneioView
    },
    data () {
        return {
          entityService: new EntityService('PackingListEmb'),
          schema: null,
          dialog: false,
          items: [],
          selected: [],
          open: false,
          openCreateRomaneio: false,
          pageCount: 0,
          pagination: {},
          page: 1,
          itemSelect: null,
          search: "",
          loading: false,
          entity: {},
          rowMenu: {
                showMenu: false,
                closeOnContentClick: false,
                x: 0,
                y: 0,
                menuX: 0,
                menuY: 0,
            },

            rowMenuOpen: false,
            actions: [
                {
                    icon: "mdi-pencil",
                    color: "warning",
                    title: "Visualizar/Editar",
                    handle: () => {
                        this.open = true
                    },
                }
            ],
        }
    },

    computed: {
        
        headersComp() {
            if (!this.schema) return [];

            let form = this.schema?.form?.properties;

            let properties = this.schema?.properties;
            let propertiesNames = Object.getOwnPropertyNames(properties || []);


            let maps = propertiesNames
                .filter((pn) => (properties[pn].relationSchema == null
                ) && form[pn])
                .map((p) => {
                    let prop = form[p];
                    return { text: prop.label, value: p };
                });

            if (this.schema.propertiesVisibleTable) {
                let propertiesVisibleTable = this.schema.propertiesVisibleTable?.split(',')
                maps.sort((a, b) => {

                let valueA = propertiesVisibleTable.indexOf(a.value);
                let valueB = propertiesVisibleTable.indexOf(b.value);

                if (valueA > valueB) return 1;
                else if (valueA < valueB) return -1;
                else return 0;


                });
            } else {
                maps.splice(maps.length - 1);
            }

            return maps;
        },
    },

    methods: {

        async getItemsListEmb(search = ''){
            const response = await this.entityService.getAll(this.page, 30, search,'codigo', null, null)
            this.items = response.data.data.data

            this.pageCount = response.data.data.pages
        },

        async rowClick(row){
            await this.timeout(100);
            this.rowMenu.menuX = this.rowMenu.x;
            this.rowMenu.menuY = this.rowMenu.y;

            this.$nextTick(() => {
                this.rowMenu.showMenu = true;
            });

            this.entity = Object.assign({}, row);
        },

        async saveListEmb(){
            await this.entityService.insertOrUpdate(this.entity)
            this.open = false
            this.$notfy.success(`Lista de embarque atualizada.`);
            await this.getItemsListEmb();
        },

        updateMouseCoordinates(event) {
            this.rowMenu.x = event.clientX;
            this.rowMenu.y = event.clientY;
        },
        
        timeout(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },

        async generatedRomaneio(romaneio){
            let romaneioPackingItems = []

            let packingItemsIds = []

            await Promise.all(this.selected.map(async (item) => {

                romaneioPackingItems.push({
                    listaDeEmbarque: item.id
                })

            }))

            const responseRomaneioItem = await Vue.prototype.$http.post('/Entity/insertMany/RomaneioPackingList', romaneioPackingItems);
            packingItemsIds = responseRomaneioItem.data.data.map((item) => item.id);

            const romaneioObj = {
                ...romaneio,
                vlrTotal: Number(romaneio.vlrTotal),
                dataCriacao: new Date().toISOString(),
                job: this.selected.map((item) => item.job),
                itens: packingItemsIds,
                quantidade: Number(romaneio.quantidade),
            }
            
            const response = await Vue.prototype.$http.post('/Entity/Romaneio', romaneioObj);
            
            if(response.data.success){
                this.$notfy.success(`Success.`);
                this.selected = []
                this.openCreateRomaneio = false;
            } else {
                this.$notfy.error("Erro.");
            }

        },

        async inputPagination(page) {
            this.page = page
            await this.getItemsListEmb()
        },
    },

    async created() {
       const url = window.location.href;
        const params = new URLSearchParams(url.split('?')[1]);
        const search = params.get('search');
        this.schema = await schemaService.getByNameToJS('PackingListEmb')
        await this.getItemsListEmb(search);
    }
}
</script>